import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: IGenericObject) => {
  return StyleSheet.create({
    main: {},
    section: {
      margin: '0 auto',
      width: '100%',
      height: '100%',
      color: 'white',
      maxWidth: 980,
      padding: '30px 15px',
      [media.tablet]: {
        padding: '30px 24px',
      },

      [media.desktop]: {
        padding: '30px 20px',
      },
    },
    title: {
      fontSize: 40,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 15,
      marginTop: 70,
      color: palette.red,
      [media.smallerThanTablet]: {
        fontSize: 25,
        marginBottom: 10,
      },
    },
    description: {
      fontSize: 20,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 70,
      [media.smallerThanTablet]: {
        padding: '0 20px',
        fontSize: 16,
        marginBottom: 35,
      },
    },
    form: {
      [children('> div:not(:last-child)')]: {
        marginBottom: 0,
      },
      [children('> div:not(:first-child)')]: {
        marginTop: 0,
      },

      [media.tablet]: {
        [children('> div:not(:last-child)')]: {
          marginBottom: 25,
        },
        [children('> div:not(:first-child)')]: {
          marginTop: 25,
        },
      },
    },
    submit: {
      display: 'block',
      margin: '75px auto',
      padding: '20px 50px',
      color: 'white',
      fontSize: 24,
      fontWeight: 'bold',
      background: `linear-gradient(180deg, rgba(230,0,18,1) 0%, rgba(152,0,12,1) 100%)`,
      borderRadius: 5,
      border: 'none',
      [media.smallerThanTablet]: {
        margin: '40px auto',
      },
      [media.desktop]: {
        background: palette.red,
      },
    },
    completionContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 40,
      marginBottom: 50,
      lineHeight: `${40 / 25}`,
      [children('h1')]: {
        fontSize: 25,
        lineHeight: 35 / 25,
        textAlign: 'center',
        marginBottom: 35,
        [media.tablet]: {
          fontSize: 35,
          lineHeight: 40 / 35,
          marginBottom: 40,
        },
      },
      [children('p')]: {
        textAlign: 'center',
        fontSize: 16,
        lineHeight: 20 / 16,
        marginBottom: 0,
        [media.tablet]: {
          fontSize: 24,
          lineHeight: 40 / 24,
        },
      },
      [children('a')]: {
        color: palette.red,
        textDecoration: 'underline',
      },
      [media.tablet]: {
        marginTop: 200,
        marginBottom: 190,
      },
      [media.desktop]: {
        marginTop: 150,
        marginBottom: 190,
      },
    },
  });
};
